// extracted by mini-css-extract-plugin
export var subHeaderStep = "OrderSteps-module--subHeaderStep--mbwqa";
export var subHeaderStepActive = "OrderSteps-module--subHeaderStepActive--msQcO";